import api from "./api";

export const getsTerapiaResumenView = async (filters) => {
    const response = await api.get('/Terapia/GetsTerapiaResumenViewbyIdFilialOrMemberOrTherapist?'
            + 'idFilial=' + (filters.idFilial == null ? 0 : filters.idFilial)
            + '&member=' + (filters.member == null ? "" : filters.member)
            + '&therapist=' + (filters.therapist == null ? "" : filters.therapist)
            + '&idEstado=' + (filters.idEstado == null ? "" : filters.idEstado)
        );

    return response.data.data;
}

export const annulTerapia = (idTerapia) =>
    api.post("/Terapia/AnnulTerapia?idTerapia=" + idTerapia);

export const activeTerapia = (idTerapia) =>
    api.post("/Terapia/ActiveTerapia?idTerapia=" + idTerapia);

export const addUpdateTherapyWithDetails = (dataPost) =>
    api.post("/Terapia/AddUpdateTherapyWithDetails", dataPost);

export const getsTerapiaHorarioView = async (idTerapia) => {
    const response = await api.get("/Terapia/GetsTerapiaHorarioView?idTerapia=" + idTerapia);

    return response.data.data;
}

export const getsTerapiaTerapeutaView = async (idTerapia) => {
    const response = await api.get("/Terapia/GetsTerapiaTerapeutaView?idTerapia=" + idTerapia);

    return response.data.data;
}

export const getsTerapiaParticipanteView = async (idTerapia) => {
    const response = await api.get("/Terapia/GetsTerapiaParticipanteView?idTerapia=" + idTerapia);

    return response.data.data;
}

export const getsTerapiaPeriodoResumenView = async (filters) => {
    const response = await api.get('/Terapia/GetsTerapiaPeriodoResumenView?'
            + 'idPeriodo=' + (filters.idPeriodo == null ? 0 : filters.idPeriodo)
            + '&idFilial=' + (filters.idFilial == null ? 0 : filters.idFilial)
            + '&idTipoTerapia=' + (filters.idTipoTerapia == null ? 0 : filters.idTipoTerapia)
            + '&participante=' + (filters.participante == null ? "" : filters.participante)
            + '&idTerapeuta=' + (filters.idTerapeuta == null ? 0 : filters.idTerapeuta)
            + '&terapeuta=' + (filters.terapeuta == null ? "" : filters.terapeuta)
            + '&idEstado=' + (filters.idEstado == null ? "" : filters.idEstado)
            + '&idTerapiaPeriodo=' + (filters.idTerapiaPeriodo == null ? 0 : filters.idTerapiaPeriodo)
        );

    return response.data.data;
}

// Genera el comprobante de un periodo de terapia que todavia no lo tiene, con el
// concepto de la tarifa y pendiente de pago.
export const generarComprobanteTerapiaPeriodo = (idTerapiaPeriodo) =>
    api.post("/Terapia/GenerarComprobanteTerapiaPeriodo?idTerapiaPeriodo=" + idTerapiaPeriodo);

export const annulTerapiaPeriodo = (idTerapiaPeriodo) =>
    api.post("/Terapia/AnnulTerapiaPeriodo?idTerapiaPeriodo=" + idTerapiaPeriodo);

export const activeTerapiaPeriodo = (idTerapiaPeriodo) =>
    api.post("/Terapia/ActiveTerapiaPeriodo?idTerapiaPeriodo=" + idTerapiaPeriodo);

export const getsTerapiaParticipanteResumenView = async (filters) => {
    const response = await api.get('/Terapia/GetsTerapiaParticipanteResumenView?'
            + 'idFilial=' + (filters.idFilial == null ? 0 : filters.idFilial)
            + '&idTipoTerapia=' + (filters.idTipoTerapia == null ? 0 : filters.idTipoTerapia)
            + '&idEstado=' + (filters.idEstado == null ? 0 : filters.idEstado)
        );

    return response.data.data;
}

// Al abrir el periodo se crea el periodo de la terapia y su comprobante con el
// concepto (la tarifa), que queda pendiente de pago.
export const addTerapiaPeriodo = (idPeriodo, idTerapia, numero, idTarifa, idPersona, codigoPeriodo, participante) =>
    api.post("/Terapia/AddTerapiaPeriodo?"
        + "idPeriodo=" + idPeriodo
        + "&idTerapia=" + idTerapia
        + "&numero=" + numero
        + "&idTarifa=" + idTarifa
        + "&idPersona=" + (idPersona == null ? 0 : idPersona)
        + "&codigoPeriodo=" + encodeURIComponent(codigoPeriodo == null ? "" : codigoPeriodo)
        + "&participante=" + encodeURIComponent(participante == null ? "" : participante)
    );

export const getsTerapiaPlanAreaView = async (idTerapia) => {
    const response = await api.get("/Terapia/GetsTerapiaPlanAreaView?idTerapia=" + idTerapia);

    return response.data.data;
}
